import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import TagsBar from '../../common/tags-bar';
import Buff from '../../common/buff';
import Level from '../level';
import './reference-box.css';

class ReferenceBox extends Component {
  _getWriterAndPublication() {
    if (this.props.writer && this.props.publication) {
      return `${this.props.writer}, ${this.props.publication}`;
    } 

    return this.props.writer || this.props.publication;
  }

  _renderBoxJSX() {
    let readMinutesJSX = '';
    if (this.props.readMinutes) {
      readMinutesJSX = <div className='read-minutes'>{this.props.readMinutes.toString().split(' ')[0]} minutes</div>                
    }

    let levelJSX = '';
    if (this.props.level) {
      levelJSX = (
        <div className='level'>
          <Level level={this.props.level} />
        </div>
      );               
    }   

    let tagsJSX = '';
    if (this.props.tags && this.props.tags.length > 0) {
      tagsJSX = (
          <div className='tags'>
            <TagsBar tags={this.props.tags} />
          </div>
      );               
    } 

    return (
      <div>
        { this.props.buffText ? <Buff text={this.props.buffText} /> : '' }

        <div 
          className='reference-image' 
          style={{'backgroundImage': `url(${this.props.imgSrc})`}}>
        </div>

        <div className='reference-textual-details'>
          { this.props.isTitleTagH4 ? <h4>{this.props.title}</h4> : <h5>{this.props.title}</h5> }

          <div className='writer-publication ellipsis'>{this._getWriterAndPublication()}</div>
          <div className='date'>{this.props.postTime}</div>
          
          {readMinutesJSX}
          
          <div className='tags-and-level'>            
            {tagsJSX}
            {levelJSX}            
          </div>
        </div>
      </div>
    );
  }

  render() {
    const boxJSX = this._renderBoxJSX();

    let linkJSX;

    if (this.props.isExternalResource) {
      linkJSX = (
        <a href={this.props.link} target='_blank' title={this.props.title}>
          {boxJSX}
        </a>
      ); 
    }
    else {
      linkJSX = (
        <Link to={this.props.link}>
          {boxJSX}
        </Link>
      ); 
    }

    return (
      <article className='reference-box'>
        {linkJSX}
      </article>
    );
  }
}

ReferenceBox.propTypes = {
  _id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  title: PropTypes.string.isRequired,
  postTime: PropTypes.string,
  link: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  isExternalResource: PropTypes.bool,
  tags: TagsBar.propTypes.tags,
  level: PropTypes.number,
  writer: PropTypes.string,
  publication: PropTypes.string,
  readMinutes: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  buffText: PropTypes.string,
  isTitleTagH4: PropTypes.bool
};

ReferenceBox.defaultProps = {
  isExternalResource: false,
  isTitleTagH4: true
};

export default ReferenceBox;